import PropTypes from "prop-types"
import MomentPropTypes from "react-moment-proptypes"

export const entitiesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string.isRequired,
    startAt: PropTypes.string.isRequired,
    endAt: PropTypes.string.isRequired,
  })
)

export const locationsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    department: PropTypes.string,
  })
)

export const subjectsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    entityName: PropTypes.string,
    entityId: PropTypes.string,
    startAt: MomentPropTypes.momentObj,
    endAt: MomentPropTypes.momentObj,
  })
)
